import { render, staticRenderFns } from "./RechargeManagementIndex.vue?vue&type=template&id=674d956b&scoped=true"
import script from "./RechargeManagementIndex.vue?vue&type=script&lang=js"
export * from "./RechargeManagementIndex.vue?vue&type=script&lang=js"
import style0 from "./RechargeManagementIndex.vue?vue&type=style&index=0&id=674d956b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "674d956b",
  null
  
)

export default component.exports